module.exports = __webpack_public_path__ + "img/selected7-min.a2e4e2d8.png";